<template>
  <div class="content extended-forms">
    <base-button class="update-button col-sm-3" @click.prevent="create()" type="confirm">작성</base-button>
    <div class="row">
      <div class="col-sm-3" v-for="(item, index) in list">
        <CardLayout
          :key="index"
          :contentId="item.id"
          :fileIds="item.fileIds"
          :title="item.title"
          :state="item.state"
          :regDate="item.displayTime"
          :btnDelete="true"
          :btnDetail="true"
          @contentDetail="goChallengeDetail"
          @deleteContent="deleteChallenge"
        />
      </div>
    </div>
  </div>
</template>
<script>
import CardLayout from "@/pages/Components/CardLayout.vue";
import swal from "sweetalert2";

export default {
  components: {
    CardLayout,
  },
  async created() {
    await this.getChallenges();
  },
  data() {
    return {
      list: [],
    };
  },
  methods: {
    async getChallenges() {
      return this.$axios.get(`/fanLogs/challenges`).then((res) => {
        this.list = res.data.data.map((data) => {
          if (data.imageFileIds) {
            const imageFileIds = JSON.parse(data.imageFileIds);
            data.fileIds = [_.find(imageFileIds, { code: "ko" })?.imageFileId];
          }
          return data;
        });
      });
    },

    async deleteChallenge(param) {
      const id = param.contentId;
      swal
        .fire({
          title: "삭제 확인",
          text: `${id}번 챌린지를 삭제하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "삭제",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios.delete(`/fanLogs/challenges/${id}`).then((res) => {
                window.Toast.success("챌린지가 삭제 되었습니다");
                this.getChallenges();
              });
            } catch (err) {
              window.Toast.error("챌린지 삭제 중 에러가 발생하였습니다.");
            }
          }
        });
    },

    goChallengeDetail(param) {
      this.$router.push(`/fanLog/challengeDetail?id=${param.contentId}`);
    },
    create() {
      this.$router.push(`/fanLog/challengeDetail`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
